export default __webpack_public_path__ + "static/media/a9.0c13395b.png";